import {
  REQUEST_APPOINTMENT_CANDIDATES,
  RECEIVE_APPOINTMENT_CANDIDATES,
  ERROR_APPOINTMENT_CANDIDATES,
  CLEAR_APPOINTMENT_CANDIDATES,
  SET_APPOINTMENT_CONTROL_NUMBER,
} from "typeConstants";
import { WebApiReduxRequestWithCallback, HTTP_GET } from "tools/webservice";

export const getCandidates = (controlIdNumber, callback) => WebApiReduxRequestWithCallback(
  REQUEST_APPOINTMENT_CANDIDATES,
  RECEIVE_APPOINTMENT_CANDIDATES,
  ERROR_APPOINTMENT_CANDIDATES,
  HTTP_GET,
  `/appointment/${controlIdNumber}/assignment-candidates`,
  callback,
  null,
  callback  // errorCallback
);

export const clearCandidates = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_APPOINTMENT_CANDIDATES,
    });
  };    
};

export const setControlNumber = (controlNumber) => {
  return dispatch => {
    dispatch({
      type: SET_APPOINTMENT_CONTROL_NUMBER,
      payload: controlNumber,
    });
  };
};